import { render, staticRenderFns } from "./completion-demo.vue?vue&type=template&id=7e40ee61&scoped=true&"
import script from "./completion-demo.vue?vue&type=script&lang=js&"
export * from "./completion-demo.vue?vue&type=script&lang=js&"
import style0 from "./completion-demo.vue?vue&type=style&index=0&id=7e40ee61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e40ee61",
  null
  
)

export default component.exports